import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="summary-table-expand"
//
// «Ver los N brokers» de la tabla resumen `mejores` (ronda 18 PRD133-1): la
// tabla muestra las primeras filas y el resto llega en el HTML con la clase
// `summary-table__row--extra`, que la hoja de estilos oculta. Al pulsar el botón
// se quitan esa clase y el propio botón. Las filas extra están en el HTML desde
// el servidor, así que el contenido completo sigue siendo indexable.
export default class extends Controller {
  static targets = ['extra', 'more']

  expand (event) {
    event.preventDefault()
    this.extraTargets.forEach((fila) => fila.classList.remove('summary-table__row--extra'))
    if (this.hasMoreTarget) this.moreTarget.remove()
  }
}
